<style scoped>
  .page-wrapper {
    /* background-color: white; */
    height: auto;
    width: 100%;
    overflow: hidden;
  }
</style>


<template>
  <div class="page-wrapper">
    <ForgotPassword :step="step" :block="'page'"></ForgotPassword>  
  </div>
</template>


<script>
import ForgotPassword from '@/components/ForgotPasswordComponent';

export default {
  name: 'PasswordResetComponent',
  components: { 
    ForgotPassword
  },
  computed: {
    step: function() {      
      return this.$route.query.step;
    }
  }
}

</script>
